import { setTermsAndConditions, setNewUserSession } from 'action-creators/user';
import { apiCall, updateSwaggerManager } from 'api';
import api, { updateDefaults, getExecute } from 'services/api/microfwk';
import apiSticky, { updateDefaultsSticky } from 'services/api/microfwkSticky';
import { setHKS } from 'utils/HKS';
import { setRegion } from 'utils/Region';
import { localStorageUpdateSession } from '../utils/updateSession';

const TERMS_ACCEPTED = 1;
const API_VERSION = 'v5.94';
const SUCCESS_STATUS = '0';

export const acceptTerms = () => async dispatch => {
  const userHash = localStorage.getItem('loginInfo.userhash');

  try {
    const { response, status, errors } = await getExecute(
      '/services/user/settermsandconditions',
      {
        user_hash: userHash,
        terminos: TERMS_ACCEPTED,
        api_version: API_VERSION,
      },
    );

    if (status !== SUCCESS_STATUS) throw new Error(errors.code);

    await dispatch(setTermsAndConditions(TERMS_ACCEPTED));

    const {
      session_stringvalue,
      region,
      session_userhash,
      user_id,
      user_token,
      user_session,
    } = response?.userData || {};

    localStorageUpdateSession({
      session_stringvalue,
      session_userhash,
      user_token,
      user_session,
    });

    setHKS(session_stringvalue);
    setRegion(region);

    updateDefaults(api, {
      params: {
        HKS: session_stringvalue,
        user_id,
      },
    });

    updateDefaultsSticky(apiSticky, {
      params: {
        HKS: session_stringvalue,
        user_session,
      },
    });

    await updateSwaggerManager(apiCall, {
      HKS: session_stringvalue,
      region,
      user_id,
      user_token
    });

    await dispatch(
      setNewUserSession({
        session_stringvalue,
        session_userhash,
        user_token,
        user_session,
      }),
    );

    return TERMS_ACCEPTED;
  } catch (e) {
    throw new Error('acceptTerms error: ', e);
  }
};
